<template>
  <div class="new-password">
    <el-input :type="inputType" v-model="password" :placeholder="labelTxt" :maxlength="maxlength" autocomplete="new-password">
      <template slot="suffix">
        <img v-if="isShow" @click="changeShow" class="right_icon" src="@/assets/pc/mask-outline.svg" />
        <img v-if="!isShow" @click="changeShow" class="right_icon" src="@/assets/pc/Icon - Unmask@3x.png" />
      </template>
    </el-input>
    <div class="password-rules">
      <div :class="{'rule-item': true, matched: item.matched}" v-for="(item, index) in rules" :key="index" >
        <img v-if="item.matched" src="@/assets/pc/success-filled.png" />
        <svg version="1.1" 
          xmlns="http://www.w3.org/2000/svg"
          viewbox="0 0 10 10"
          width="16"
          height="16"
          v-if="!item.matched"
        >
          <circle cx="7" cy="9" r="6"  stroke="#C2C2C1" fill="transparent" stroke-width="1"/>
        </svg>
        <span>{{ item.tip }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewPassword",
    props: {
      'labelTxt': {
        type: String,
        default: 'New Password'
      },
      'maxlength': {
        type: String,
        default: '16'
      },
    },
    data() {

      return {
        password: '',
        rules: [
          {
            tip: '8-16 characters in length',
            matched: false,
          },
          {
            tip: 'Contains a lowercase letter',
            matched: false,
          },
          {
            tip: 'Contains an uppercase letter',
            matched: false,
          },
          {
            tip: 'Contains a number',
            matched: false,
          },
          {
            tip: 'Contains a Special character',
            matched: false,
          }
        ],
        isShow: true,
        inputType: 'password'
      }
    },
    methods: {
      changeShow() {
        this.isShow = !this.isShow
        if (this.isShow) {
          this.inputType = 'password'
        } else {
          this.inputType = 'text'
        }
      }
    },
    watch: {
      password(val) {

        this.rules[0].matched = val.length > 7 && val.length < 17;
        this.rules[1].matched = /[a-z]/.test(val);
        this.rules[2].matched = /[A-Z]/.test(val);
        this.rules[3].matched = /[0-9]/.test(val);
        this.rules[4].matched = /[`~!@#$%^&*()_\-+=<>?:"{}|,.;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、/]/im.test(val);

        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss">
  .new-password {
    .right_icon {
      width: 24px;
      height: 24px;
      vertical-align: middle;
      margin-top: 7px;
      cursor: pointer;
    }

    .password-rules {

      .rule-item {
        display: flex;
        height: 22px;
        align-items: center;
        margin: 8px 0;

        img {
          width: 16px;
          height: 16px;
        }

        span {
          margin: 0 0 0 8px;
          font: normal normal normal 14px/24px Nunito;
          letter-spacing: 0px;
          color: #919191;
        }

        &.matched {
          span {
            color: #2E2E2E;
          }
        }
      }
    }
  }
</style>